import { defineStore } from 'pinia';
import fetch_request from '/src/requests/requests.js';
import { LocalStorage } from 'quasar';

const GENERIC_ERROR = 'Something went wrong. Please try again.';

const normalizeError = (value) => {
  const asText = (v) => (typeof v === 'string' && v.trim() !== '' ? v : null);

  const direct = asText(value);
  if (direct) return direct;

  if (value && typeof value === 'object') {
    const bag = value.errors;
    if (bag && typeof bag === 'object') {
      for (const messages of Object.values(bag)) {
        const text = asText(Array.isArray(messages) ? messages[0] : messages);
        if (text) return text;
      }
    }

    const message = asText(value.error) || asText(value.message);
    if (message) return message;
  }

  return GENERIC_ERROR;
};

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    isAuthenticated: false,
    loading: false,
    error: null,
  }),
  
  getters: {
    getUser: (state) => state.user,
    getIsAuthenticated: (state) => state.isAuthenticated,
  },
  
  actions: {
    async register(userData) {
      this.loading = true;
      this.error = null;
      try {
        const response = await fetch_request('/register', 'POST', userData);
        if (response.token || response.access_token) {
          const token = response.token || response.access_token;
          LocalStorage.set('access_token', token);
          this.isAuthenticated = true;
          this.user = response.user;
          return true;
        } else if (response.error || response.errors) {
          this.error = normalizeError(response);
          return false;
        }
        return true;
      } catch (err) {
        this.error = normalizeError(err);
        return false;
      } finally {
        this.loading = false;
      }
    },
    
    async login(credentials) {
      this.loading = true;
      this.error = null;
      try {
        const response = await fetch_request('/login', 'POST', {...credentials});
        if (response.token || response.access_token) {
          const token = response.token || response.access_token;
          LocalStorage.set('access_token', token);
          this.isAuthenticated = true;
          this.user = response.user;
          return true;
        } else if (response.error || response.errors) {
          this.error = normalizeError(response);
          return false;
        }
        return true;
      } catch (err) {
        this.error = normalizeError(err);
        return false;
      } finally {
        this.loading = false;
      }
    },
    
    async fetchUser() {
      if (!LocalStorage.getItem('access_token')) {
        this.isAuthenticated = false;
        return;
      }
      this.loading = true;
      try {
        const response = await fetch_request('/user', 'GET');
        if (response && (response.id || response.user)) {
          this.isAuthenticated = true;
          this.user = response.user || response;
        } else {
          console.log('else fetchUser')
          // this.logout();
        }
      } catch {
          console.log('catch fetchUser')

        // this.logout();
      } finally {
        this.loading = false;
      }
    },
    
    async logout() {
      try {
        if (LocalStorage.getItem('access_token')) {
          await fetch_request('/logout', 'POST');
        }
      } catch (e) {
        console.error('Logout error', e);
      } finally {
        LocalStorage.remove('access_token');
        this.isAuthenticated = false;
        this.user = null;
      }
    }
  }
});
